import './eventpage.less'

import {Block, BlockType} from 'blocks/block'
import {Blocks} from 'blocks/blocks'
import React from 'react'
import {ImageOrSvgType, PageData} from 'types'
import {style} from 'util/style'
import {Fshero, FsheroType} from 'views/hero/fshero'
import {Layout} from 'views/layout'
import {CountdownType} from 'views/layout/countdown'

const styles = style('eventpage')

export const EventPage: React.FC<PageData & {
	fshero: FsheroType
	countdown?: CountdownType
	logos_light?: ImageOrSvgType
	blocks: Array<BlockType>
}> = data => {
	const {fshero, countdown, logos_light, blocks} = data

	return (
		<Layout page={data}>
			<div className={styles()}>
				<Fshero {...fshero} countdown={countdown} logos_light={logos_light} />
				<Blocks className={styles('blocks')}>
					{blocks.map((block, i) => (
						<Block key={i} {...block} />
					))}
				</Blocks>
			</div>
		</Layout>
	)
}
